import renderStatuses from './render-statuses';
import fieldNames from './field-names';

export default {
  renderStatuses,
  fieldNames,
  CUSTOM_HTML_TAG: 'ws-html-embed',
  TEMPLATE_TAG: 'template',
  RUNTIME_RENDERING_ATTRIBUTE: 'runtime-rendering',
  RUNTIME_CONTAINER_CLASS: 'runtime-rendering-content',
};
